import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListChangePointSetting = createAsyncThunk(
    "changePoint/getListChangePointSetting",
    async ({ currentPage, pageSize}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/points?has_paginate&size=${pageSize}&page=${currentPage}`;
            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const updateChangePointSetting = createAsyncThunk(
    "changePoint/updateChangePointSetting", // Đổi tên hành động cho phù hợp
    async ({ id, data }, { rejectWithValue }) => { // Lấy đối tượng có `id` và `data`
      try {
        const response = await http.put(`/api/v1/serviceconnect/points/${id}`, data); // Gọi API PUT
        return response.data; // Trả về kết quả thành công
      } catch (error) {
        return rejectWithValue(error.response.data); // Trả về lỗi nếu có
      }
    }
  );
  
  export const createChangePointSetting = createAsyncThunk(
    "changePoint/createChangePointSetting",
    async (data, { rejectWithValue }) => {
      try {
        const response = await http.post(`/api/v1/serviceconnect/points`, data);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  
  export const deleteChangePointSetting = createAsyncThunk(
    "changePoint/deleteChangePointSetting",
    async (id, { rejectWithValue }) => {
      try {
        const response = await http.delete(`/api/v1/serviceconnect/points/${id}`);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );
  